import React, {useEffect} from "react";
import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Divider, Form, Select } from "semantic-ui-react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";


const ProductEdit = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const [idGender, setIdGender] = useState([])
    const [idSegment, setIdSegment] = useState([])
    const [genderList, setGenderList] = useState([])
    const [segmentList, setSegmentList] = useState([])
    const [productDesc, setProductDesc] = useState('')
    const [productName, setProductName] = useState('')
    const [metaTitle, setMetaTitle] = useState('')
    const [metaDesc, setMetaDesc] = useState(null)
    const [category, setCategory] = useState([])
    const [defaultCat, setDefaultCat] = useState([])
    const [selectedCat, setSelectedCat] = useState([])
    const [idProduct, setIdProduct] = useState(null)
    const [selectedGroup, setSelectedGroup] = useState("")
    const [sizeGroup, setSizeGroup] = useState([])
    const [loading, setLoading] = useState(false)

    const [sizeListMaster, setSizeListMaster] = useState([])
    const [sizeListGroup, setSizeListGroup] = useState([])
    const [selectedSizeGroupList, setSelectedSizeGroupList] = useState("")
    const [productSizeList, setProductSizeList] = useState([])
    const [productNameSub, setProductNameSub] = useState('')


    const handleSubmit = () => {
        if (idProduct && productName && idGender && idSegment && selectedCat && metaTitle){
        setLoading(true)
        let data = {
            id_product : idProduct,
            product_name : productName,
            product_name_sub : productNameSub,
            meta_title : metaTitle,
            product_desc : productDesc,
            meta_description : metaDesc,
            id_gender : idGender,
            id_segment : idSegment,
            category : selectedCat,
            size_group : selectedGroup,
            size_head_id : selectedSizeGroupList
        }
      
        axios.post("https://hoopsdevteam.com/api_web/controler/hoops/updateProduct.php/?index=1", data)
        .then(res => {
            if (res.data.state === 200){
               navigate('/product')
               setLoading(false)
            }
        })
        } else {
            alert('Please complete it first before submit..!')
        }
    }

    const handleChangeCat = (e, {value}) => { 
        let valueJson = value.map(i => JSON.parse(i)) 
        setSelectedCat(valueJson)
    }

    const handleChangeSizeGroup = (e, {value}) => {
        setSelectedGroup(value)
    }

    
    const handleChangeSizeList = (e, {value}) => {
        setSelectedSizeGroupList(value)
        console.log(selectedSizeGroupList)
    }

    useEffect(() => {
        // POPULATE LIST GENDER
        const getGenderList = async () => {
            await axios.get("https://hoopsdevteam.com/api_web/controler/cms.php/?index=3")
                .then(res => {
                    if (res.data.state === 200) {
                        let data = res.data.data
                        let opt = []
                        data.map(item => (
                            opt.push(
                                {
                                    key: item.id_gender,
                                    value: item.id_gender,
                                    text: item.gender
                                }
                            )
                        ))
                        setGenderList(opt)
                    }
                })
        }
        // POPULATE LIST SEGMENT
        const getSegmentList = async () => {
            await axios.get("https://hoopsdevteam.com/api_web/controler/cms.php/?index=4")
                .then(res => {
                    if (res.data.state === 200) {
                        let data = res.data.data
                        let opt = []
                        data.map(item => (
                            opt.push(
                                {
                                    key: item.id_segment,
                                    value: item.id_segment,
                                    text: item.name
                                }
                            )
                        ))
                        setSegmentList(opt)
                    }
                })
        }
    
        const getCategory =  async () => {
            await axios.get('https://hoopsdevteam.com/api_web/controler/category.php/?index=3', {
                headers: {
                    'Authorization': '9c98dh92db9ejn' 
                }
            })
            .then(res => { 
                if (res.data.length > 0 ) {
                    setCategory(res.data.map((item,i) => (
                        {
                            key:i,
                            text:(item.child_name) ? item.parent_name + ' > ' + item.child_name : item.parent_name,
                            value: JSON.stringify({id_parent:item.id_parent, id_child:item.id_child}), // UBAH JADI STRING SOALNYA GA BISA OBJECT
                        }
                    )))
                }
            })
        } 

        const categoryByProduct = async (id) => {
            let data = {
                id_product : id
            }
            await axios.post("https://hoopsdevteam.com/api_web/controler/cms.php/?index=17",data )
            .then(res => { 
                if (res.data.state === 200){
                    setSelectedCat(res.data.data.map((item,i) => (
                        { 
                            id_parent:item.id_category,
                            id_child:item.id_category_child,
                        }
                    )))
                    setDefaultCat(res.data.data.map((item,i) => JSON.stringify(
                        { 
                            id_parent:item.id_category,
                            id_child:item.id_category_child,
                        }
                    )))
                }
            })
        }

        const getSizeGroup = async () => {
            axios({
                method: "POST",
                url: `${global.SRV}api_hoops_cms/controler/product.php/?index=4`,
                headers: { 'Content-Type': 'application/json' },
            }).
                then(res => {
                    if (res.data.state === 200) {
                        setSizeGroup(res.data.data.map((item,i) => (
                            {
                                key:i,
                                text:item.group_name,
                                value: item.group_name,
                            }
                        )))
                    }
                })
        }

        const getSizeList = async () => {
            await axios.get('https://hoopsdevteam.com/api_web/controler/hoops/size.php?index=88')
            .then(res => {
                if (res.data.state === 200) {

                    let data = res.data.data

                    setSizeListMaster(data)

                    // GROUP UNIQUE BY CODE
                    let uniqueGroup = [
                        ...new Map(
                            data.map(item => [
                                item.code,
                                {
                                    key: item.code,
                                    text: item.name,
                                    value: item.head_id
                                }
                            ])
                        ).values()
                    ]

                    setSizeListGroup(uniqueGroup)
                }
            })
        }
        
        const getSizeListByProductId = async (id) => {
            await axios.get(
                "https://hoopsdevteam.com/api_web/controler/hoops/size.php?index=99",
                {
                    params: {
                        id_product: id
                    }
                }
            )
            .then(res => {
                if (res.data.state === 200) {
                    setProductSizeList(res.data.data)
                }
            })
        }

        getGenderList()
        getSegmentList()
        getCategory()
        categoryByProduct(location.state.selected.id_product)
        getSizeGroup()
        getSizeList()
        getSizeListByProductId(location.state.selected.id_product)
    }, [])

    useEffect(() => {
        let idGender = genderList.length > 0 && genderList.find(o => o.text === location.state.selected.gender).value
        let idSegment = segmentList.length > 0 && segmentList.find(o => o.text === location.state.selected.segment_name).value
        
        setIdProduct(location.state.selected.id_product)
        setProductName(location.state.selected.product_name)
        setProductNameSub(location.state.selected.product_name_sub)
        setMetaTitle(location.state.selected.meta_title)
        setProductDesc(location.state.selected.product_desc ? location.state.selected.product_desc : '')
        setMetaDesc(location.state.selected.meta_description ? location.state.selected.meta_description : '')
        //setIdGender(genderList.length > 0 && genderList.find(o => o.text === location.state.selected.gender).value)
        //if(genderList.length > 0) setIdGender(idGender) 
        //if(segmentList.length > 0) setIdSegment(idSegment) 
        setIdGender(location.state.selected.id_gender ? location.state.selected.id_gender : '')
        setIdSegment(location.state.selected.id_segment ? location.state.selected.id_segment : '')

        setSelectedGroup(location.state.selected.size_group)
        setSelectedSizeGroupList(location.state.selected.size_head_id ? location.state.selected.size_head_id : '')
    
    }, [location.state.selected, segmentList])

   
    return (
        <Container fluid>
            <Row>
                <div className="text-facebook h3 mb-0">Product Edit</div>
                <span className="text-muted">Edit selected product</span>
            </Row>
            <Divider />
            <Row className="d-flex justify-content-center mt-5 mb-5">
                <Col xl={8} lg={8} md={8} sm={8}>
                    <Form widths="equal" onSubmit={handleSubmit}>
                        <Form.Input label="Product Name" value={productName} onChange={(e, { value }) => setProductName(value)} />
                        <Form.Input label="Product Name Sub" value={productNameSub} onChange={(e, { value }) => setProductNameSub(value)}/>
                        <Form.TextArea label='Product Description' value={productDesc} onChange={(e, {value}) => setProductDesc(value)}/>
                        <Form.Input label="Meta Title" value={metaTitle} onChange={(e, { value }) => setMetaTitle(value)} required/>
                        <Form.TextArea label='Meta Description' value={metaDesc} onChange={(e, {value}) => setMetaDesc(value)} maxLength={255}/>
                        {defaultCat.length > 0 && category.length > 0 ? 
                            <Form.Dropdown 
                                required
                                search
                                control={Select}
                                options={category} 
                                label={{children: 'Category'}} 
                                onChange={handleChangeCat} 
                                multiple 
                                defaultValue={defaultCat}
                            /> : <></>
                        }
                        
                        <Row>
                            <Col className="mb-3" xl={6} lg={6} md={6} sm={6}>
                                <Form.Select control={Select} value={idGender} options={genderList} label={{ children: 'Gender' }} onChange={(e, {value}) => setIdGender(value)}/>
                            </Col>
                            <Col className="mb-3" xl={6} lg={6} md={6} sm={6}>
                                <Form.Select control={Select} value={idSegment} options={segmentList} label={{ children: 'Segment' }} onChange={(e, {value}) => setIdSegment(value)}/>
                            </Col>
                        </Row>

                        <Row>
                            <Col className="mb-3" xl={6} lg={6} md={6} sm={6}>
                                <Form.Dropdown
                                    required
                                    search
                                    control={Select}
                                    options={sizeGroup}
                                    label="Size Group"
                                    value={selectedGroup}
                                    onChange={handleChangeSizeGroup}
                                />
                            </Col>
                            <Col className="mb-3" xl={6} lg={6} md={6} sm={6}>
                                <Form.Dropdown
                                    search
                                    selection
                                    control={Select}
                                    options={sizeListGroup}
                                    label="Size List"
                                    value={selectedSizeGroupList}
                                    onChange={handleChangeSizeList}
                                    //onChange={(e, { value }) => setSelectedSizeGroupList(value)}
                                />
                            </Col>
                        </Row>
                        
                        { productSizeList.length > 0 &&
                            <div
                                className="rounded p-3 mb-4 mt-2"
                                style={{
                                    background: '#e7f3ff',
                                    border: '1px solid #91caff'
                                }}
                            >

                                <div
                                    className="fw-bold mb-2"
                                    style={{ color: '#0958d9' }}
                                >
                                    ℹ Available Sizes
                                </div>

                                <div
                                    className="mb-3"
                                    style={{
                                        color: '#1d39c4',
                                        fontSize: '0.95rem'
                                    }}
                                >
                                    These sizes are currently available for this product.
                                </div>

                                <div className="d-flex flex-wrap gap-2">

                                    {
                                        productSizeList.map((size, i) => (
                                            <div
                                                key={i}
                                                className="px-3 py-1 rounded"
                                                style={{
                                                    background: 'white',
                                                    border: '1px solid #b6d4fe',
                                                    fontSize: '0.9rem',
                                                    color: '#003eb3'
                                                }}
                                            >
                                                {size}
                                            </div>
                                        ))
                                    }

                                </div>

                            </div>
                        }

                        { selectedSizeGroupList &&
                            <div
                                className="rounded p-3 mb-4 mt-2"
                                style={{
                                    background: '#fff8c5',
                                    border: '1px solid #9a6700'
                                }}
                            >

                                <div
                                    className="fw-bold mb-2"
                                    style={{ color: '#9a6700' }}
                                >
                                    ⚠ Size List Preview
                                </div>

                                <div
                                    className="mb-3"
                                    style={{ color: '#756000', fontSize: '0.95rem' }}
                                >
                                    These sizes will be displayed on the website product page.
                                </div>

                                <div className="d-flex flex-wrap gap-2">
                                    {
                                        sizeListMaster
                                        .filter(item => item.head_id === selectedSizeGroupList)
                                        .sort((a, b) => parseFloat(a.sort_order) - parseFloat(b.sort_order))
                                        .map((size, i) => (
                                            <div
                                                key={i}
                                                className="px-3 py-1 rounded"
                                                style={{
                                                    background: 'white',
                                                    border: '1px solid #d0d7de',
                                                    fontSize: '0.9rem'
                                                }}
                                            >
                                                {size.size_value}
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        }

                        <Form.Button className="mt-5" loading={loading} disabled={loading} content="Update" type="submit" color="facebook"/>
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}

export default ProductEdit